module.exports = __webpack_public_path__ + "favicon-96x96.d168f2e6.png";